export default __webpack_public_path__ + "static/media/blue2.d971b598.png";